<template>
  <div>
    <div
      v-for="(profession, index) in parentProfessions"
      :key="profession.id"
    >
      <div class="Radio-container u-flex">
        <rmp-radio
          :id="`profession+${index}`"
          v-model="fields.parent_profession"
          :label="profession.text"
          :value="profession.value"
          :name="`profession+${profession.id}`"
          class="RadioButton-profession"
          @change="$emit('parent-profession-selection', profession.value)"
        />
        <div
          v-if="profession.hint !== ''"
          class="Hint-container"
        >
          <i
            class="fa fa-question-circle"
            @click="toggleInfoHint(profession.id)"
          />
        </div>
      </div>
      <p
        v-if="toggleHint.includes(profession.id)"
        class="Notice Notice--info"
      >
        {{ profession.hint }}
      </p>
    </div>
  </div>
</template>
<script>
import RmpRadio from '@/components/form/radio-button.vue';

export default {
  components: {
    RmpRadio,
  },
  props: {
    parentProfessions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      toggleHint: [],
      fields: {
        parent_profession: null,
      },
    };
  },
  methods: {
    toggleInfoHint(id) {
      if (this.toggleHint.includes(id)) {
        this.toggleHint.splice(this.toggleHint.indexOf(id, 1));
      } else {
        this.toggleHint.push(id);
      }
    },
  },
};
</script>
